/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleWithPermissionsResponseDto } from './RoleWithPermissionsResponseDto';
import {
    RoleWithPermissionsResponseDtoFromJSON,
    RoleWithPermissionsResponseDtoFromJSONTyped,
    RoleWithPermissionsResponseDtoToJSON,
    RoleWithPermissionsResponseDtoToJSONTyped,
} from './RoleWithPermissionsResponseDto';

/**
 * 
 * @export
 * @interface ListRolesWithPermissionsResponseDto
 */
export interface ListRolesWithPermissionsResponseDto {
    /**
     * 
     * @type {Array<RoleWithPermissionsResponseDto>}
     * @memberof ListRolesWithPermissionsResponseDto
     */
    data: Array<RoleWithPermissionsResponseDto>;
}

/**
 * Check if a given object implements the ListRolesWithPermissionsResponseDto interface.
 */
export function instanceOfListRolesWithPermissionsResponseDto(value: object): value is ListRolesWithPermissionsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListRolesWithPermissionsResponseDtoFromJSON(json: any): ListRolesWithPermissionsResponseDto {
    return ListRolesWithPermissionsResponseDtoFromJSONTyped(json, false);
}

export function ListRolesWithPermissionsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListRolesWithPermissionsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(RoleWithPermissionsResponseDtoFromJSON)),
    };
}

export function ListRolesWithPermissionsResponseDtoToJSON(json: any): ListRolesWithPermissionsResponseDto {
    return ListRolesWithPermissionsResponseDtoToJSONTyped(json, false);
}

export function ListRolesWithPermissionsResponseDtoToJSONTyped(value?: ListRolesWithPermissionsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(RoleWithPermissionsResponseDtoToJSON)),
    };
}

